import { useMemo, useState } from "react";
import { ContactResponse } from "../../../../core/api/contacts/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { PopupMenu } from "../../../../ui-lib/components/Menus/PopupMenu";
import { PopupContextMenuLinkButton } from "../../../../ui-lib/components/Menus/PopupContextMenu/PopupContextMenuLinkButton";
import AddCommonContactModal from "./AddCommonContactModal";
import CreatePrivateContactModal from "./CreatePrivateContactModal";

const AddContactActions = ({
  objectId,
  contacts,
  onContactUpdate,
}: {
  objectId: string;
  contacts: ContactResponse[];
  onContactUpdate: () => void;
}) => {
  const t = useTranslations();
  const { config } = useUser();

  const [createCommonContactModalOpen, setCreateCommonContactModalOpen] =
    useState(false);
  const [addContactModalOpen, setAddContactModalOpen] = useState(false);

  const hasTrygghetsjourenJourledRole = useMemo(
    () => config?.show.includes("ShowObjectDetailsVariant1"),
    [],
  );

  return (
    <>
      <PopupMenu
        variant="secondary"
        image="user-add"
        buttonText={t("Contacts:add")}
      >
        <>
          <PopupContextMenuLinkButton
            icon="user"
            text={t("Contacts:create_contact")}
            onClick={() => setCreateCommonContactModalOpen(true)}
          />

          {!hasTrygghetsjourenJourledRole && (
            <PopupContextMenuLinkButton
              icon="user-group"
              text={t("Contacts:add")}
              onClick={() => setAddContactModalOpen(true)}
            />
          )}
        </>
      </PopupMenu>
      {createCommonContactModalOpen && (
        <CreatePrivateContactModal
          createCommonContactModalOpen={createCommonContactModalOpen}
          setCreateCommonContactModalOpen={setCreateCommonContactModalOpen}
          objectId={objectId}
          onAdd={() => {
            onContactUpdate();
            setCreateCommonContactModalOpen(false);
          }}
        />
      )}
      {addContactModalOpen && (
        <AddCommonContactModal
          addContactModalOpen={addContactModalOpen}
          objectId={objectId}
          added={contacts.map((c) => c.id)}
          onClose={() => setAddContactModalOpen(false)}
          onAdd={onContactUpdate}
        />
      )}
    </>
  );
};

export default AddContactActions;
